import { render, staticRenderFns } from "./LayoutAuthNew.vue?vue&type=template&id=89c39da2&"
import script from "./LayoutAuthNew.vue?vue&type=script&lang=js&"
export * from "./LayoutAuthNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports